import { Icon, Label, PrimaryButton, Stack, Text, useTheme } from '@fluentui/react';
import * as React from 'react';
import { IOrder } from '../../../Models/Order/IOrder';
import { useNavigate } from "react-router-dom";
import { EventTypeEnum } from '../../../Models/Event/EventTypeEnum';
import { IEvent } from '../../../Models/Event/IEvent';

interface INewOrderConfirmationViewProps {
    order: IOrder;
    event?: IEvent;
    isAuth: boolean;
}


export const NewOrderConfirmationView: React.FunctionComponent<INewOrderConfirmationViewProps> = (props) => {

    const theme = useTheme();
    const navigate = useNavigate();

    const getUrl = (type?: EventTypeEnum): string => {
        switch (type) {
            case EventTypeEnum.Lessons: return "/Events";
            case EventTypeEnum.Camp: return "/Tabory";
            case EventTypeEnum.Training: return "/Skoleni";
            default:return "/Events"
        }
    }

    return (<Stack tokens={{ childrenGap:20 }}>
        <h2>A je to!</h2>
        {!props.isAuth?
        <Stack styles={{ root: { color: theme.semanticColors.errorText } }}>
            <Stack horizontal tokens={{ childrenGap: 15 }}>
                <Icon iconName="CheckMark" styles={{ root: { fontSize: 20, fontWeight: 600, color: theme.semanticColors.successText } }} />
                <Text styles={{ root: { fontWeight: 600 } }}>Registrace byla úspěšně vytvořena</Text>
            </Stack>
            <Text styles={{ root: { fontStyle: 'italic' } }}>Informace jak dokončit registraci jsme odeslali na vámi zadaný email <b>{props.order.email}</b></Text>
        </Stack>:null}
        <Stack styles={{ root: { color: theme.semanticColors.successText } }}> 
            <Stack horizontal tokens={{ childrenGap: 15 }}>
                <Icon iconName="CheckMark" styles={{ root: { fontSize: 20, fontWeight: 600 } }} />
                <Text styles={{ root: { fontWeight: 600 } }}>Vaše objednávka byla úspěšně uložena pod číslem {props.order.id}</Text>
            </Stack>
            <Text styles={{ root: { fontStyle: 'italic' } }}>Potvrzení objednávky bylo odesláno na váš email <b>{props.order.email}</b>. Stav vaší objednávky můžete sledovat po přihlášení na
                  www.tomebavi.eu nebo vás budeme informovat emailem.
            </Text>
        </Stack>
        <Stack horizontal wrap horizontalAlign="center" tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 20 } }}>
            <PrimaryButton text="Vybrat další akci" onClick={() => window.location.href = getUrl(props.event?.eventTypeEnum)} />
        </Stack>
    </Stack>)
}
